export class EPSGInfo {
    horizontal: string;
    vertical: string;

    constructor(horizontal: string, vertical: string) {
        this.horizontal = horizontal;
        this.vertical = vertical;
    }
    getCRS = () => {
        if (this.horizontal === "" && this.vertical === "") {
            return "";
        }
        let crs = "";
        if (this.horizontal !== "") {
            crs = `EPSG:${this.horizontal}`;
        }
        if (this.vertical !== "") {
            crs = `${crs}+${this.vertical}`;
        }
        return crs;
    }
    getHorizontalCRS = (): string => {
        if (!this.horizontal) {
            return "";
        }
        return `${this.horizontal}`;
    }
    getVerticalCRS = () => {
        if (this.vertical === "") {
            return "";
        }
        return `${this.vertical}`;
    }
}